import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SkillDetailsSegment from './SkillDetailsSegment';
import ActionSegment from './ActionSegment';
import ReprocessingSegment from './ReprocessingSegment';
import CSVSegment from './CSVSegment';
import BundleSegment from './BundleSegment';

class ActionBar extends Component {
    render() {
        const { mediaItems, scene } = this.props;
        const selectedItems = (mediaItems)
            ? mediaItems.filter(media => 'selected' in media && media.selected)
            : [];

        const anySelected = mediaItems && selectedItems.length > 0;
        const inScene = scene !== '';

        return (
            <div className="activity-header">
                <div className="container">
                    <div key='activity-bar' className="activity-bar">

                    </div>
                    <div className="clear"></div>
                </div>
                <div key='ab_activity-actions' className="activity-actions">
                    <SkillDetailsSegment key='skill' inScene={inScene} anySelected={anySelected} />
                    <ActionSegment key='action' inScene={inScene} anySelected={anySelected} />
                    <CSVSegment key='csv' inScene={inScene} />
                    <ReprocessingSegment key='reprocessing' inScene={inScene} anySelected={anySelected} />
                    <BundleSegment key='bundle' inScene={inScene} />
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => {
    const scene = state.scene.current;
    const sceneMedia = state.mediaByScene[scene];
    const mediaItems = sceneMedia ? sceneMedia.mediaItems : [];

    return {
        mediaItems,
        scene
    };
};

ActionBar.propTypes = {
    mediaItems: PropTypes.array,
    scene: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(ActionBar);



// WEBPACK FOOTER //
// ./src/components/actionBar/ActionBar.js